import { defineStore } from 'pinia';
import { store } from '/@/store';
import { ProductDetailType } from '/@/api/exchangeService/model/product';
import { useRouter } from 'vue-router';
import { droDetailInfoApi } from '/@/api/exchangeService';

// const initData: ProductDetailType = {
//   productCode: 'ACJA001901',
//   productType: 1,
//   releaseAmount: 100000,
//   totalShares: 500,
//   yieldItd: 1.12,
//   shareAmountItd: 672000,
//   planBeginDate: 1649260800000,
//   planExitDate: 1717776000000,
//   planDateLength: 793,
//   industryName: '零售',
//   industryCode: '02',
//   industryEngName: 'Retail',
//   sectorName: '用品零售',
//   sectorCode: '0203',
//   sectorEngName: 'Goods Retail',
//   categoryName: '潮流饰品',
//   categoryCode: '020312',
//   categoryEngName: 'Trendy Accessories',
//   province: '浙江省',
//   provinceCode: 'null',
//   provinceEngName: 'Zhejiang',
//   city: '杭州市',
//   cityCode: 'null',
//   cityEngName: 'Hangzhou',
//   district: 'null',
//   districtCode: '330105',
//   districtEngName: 'GongshuQu',
//   droInitIndex: {
//     id: 108948319110127,
//     droCode: 'ACJA001901',
//     inputFcfValues: 'null',
//     dailyIrr: 0.0004370748508662,
//     yearIrr: 0.1729212930064614,
//     irp: 1025,
//     recoveryInit: 1.2,
//     incomeratioBefAvg: 1.5,
//     shareAmountTotalInit: 361176.4,
//     nav: 277828,
//     type: 1,
//     dataStatus: 1,
//   },
//   droIoIndex: {
//     ioDayLength: 3731,
//     turnoverDay: 9,
//     incomeratioAvg: 1.5,
//     armExceptionRate: 9,
//   },
//   storeIndex: {
//     id: 108944828013001,
//     shopCode: 'ACJA-0019',
//     monthlybesturnover: 4426,
//     hisTurnoverDay: 4426,
//     hisTurnoverMonth: 12251,
//     turnoverYear: '9',
//     usablearea: 4426,
//     leaseAmount: 12251,
//     besNetIncome: 41346,
//     besCash: 23330,
//     besProp: 30508,
//     armExceptionRate: 0.16,
//     leadPeriodStartDate: '2013-03-05',
//     leadPeriodEndDate: '2033-10-09',
//     ccaEstablishDate: '2013-03-05',
//     dataStatus: 1,
//     shopPattern: 'null',
//     shopOpenDayLength: 900,
//   },
//   brandIndex: {
//     id: 0,
//     brandCode: 'ACJA',
//     ccaId: 2,
//     brandName: '测是',
//     ccaEntNum: 555,
//     ccaEnddivideNum: 445,
//     ccaEarlyCloseNum: 6,
//     ccaIrpAvg: 3,
//     ccaCloseRate: 0.2,
//     ccaEstablishDate: '2023-05-22',
//     dataStatus: 1,
//   },
// };
interface ProductState {
  productInfo: {
    [key: string]: Promise<ProductDetailType>;
  };
}
export const useProductStore = defineStore({
  id: 'product-detail',
  state: (): ProductState => ({
    productInfo: {
      // ACJA001901: Promise.resolve(initData),
    },
  }),
  getters: {
    getProductDetail(): Promise<ProductDetailType> {
      const router = useRouter();
      const { currentRoute } = router;
      const { productCode } = currentRoute.value.params;
      return this.productInfo[productCode as string];
    },
  },
  actions: {
    fetchProductData(productCode: string | null = null) {
      if (!productCode) {
        const router = useRouter();
        const { currentRoute } = router;
        productCode = currentRoute.value.params.productCode as string;
      }

      this.productInfo[productCode] = droDetailInfoApi({ productCode });
    },
  },
});

// Need to be used outside the setup
export function useProductStoreWithOut() {
  return useProductStore(store);
}
